import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4b4ef303"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "addition-set" }
const _hoisted_2 = { class: "addition-set-search" }
const _hoisted_3 = { class: "addition-set-title" }
const _hoisted_4 = { class: "addition-set-table" }
const _hoisted_5 = { style: {"max-width":"400px"} }
const _hoisted_6 = { class: "line--2" }
const _hoisted_7 = { key: 1 }

import { getCustomerAdditionTemplateListApi, updateCustomerAdditionTemplateStatusApi, getAdditionTemplateDetailApi } from '@/apis/addition'
import STable from '@/components/Table/index.vue'
import { t } from '@/plugins/i18n'
import { ref, nextTick } from 'vue'
import { additionSetColumns, tableConfig } from './data'
import CreateAdditionTemplate from '@/components/additional/CreateAdditionTemplate.vue'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const STableRef = ref()
const form = ref({
  templateName: '',
  templateType: '',
  templateStatus: ''
})
const pageData = ref({
  page: 1,
  limit: 30
})
const filterData = ref({})
const search = () => {
  pageData.value = {
    page: 1,
    limit: 30
  }
  filterData.value = form.value
  nextTick(() => {
    STableRef.value && STableRef.value.getData()
  })
}
const clear = () => {
  form.value = {
    templateName: '',
    templateType: '',
    templateStatus: ''
  }
  search()
}
const templateVisible = ref(false)
const additionTemplateId = ref('')
const proxy:any = ref({})
const openCreateAdditionDialog = (item?: any) => {
  if (item?.additionTemplateId) {
    item.loading = true
    getAdditionTemplateDetailApi({
      additionTemplateId: item?.additionTemplateId
    }).then((res: any) => {
      if (res.success) {
        proxy.value = res?.data || {}
        templateVisible.value = true
      }
    }).finally(() => {
      item.loading = false
    })
  } else {
    proxy.value = {}
    templateVisible.value = true
  }
}
const refreshTable = (type?: boolean) => {
  if (type) {
    pageData.value = {
      page: 1,
      limit: 30
    }
  }
  nextTick(() => {
    STableRef.value && STableRef.value.getData()
  })
}
const changeStatus = (row: any) => {
  updateCustomerAdditionTemplateStatusApi({
    additionTemplateId: row.additionTemplateId,
    templateStatus: row.templateStatus === 1 ? 2 : 1
  }).then((res: any) => {
    if (res.success) {
      nextTick(() => {
        STableRef.value && STableRef.value.getData()
      })
    }
  })
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_table_button = _resolveComponent("table-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('附加项组合')), 1),
        _createVNode(_component_el_form, {
          inline: true,
          model: form.value,
          class: "form"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: _unref(t)('组合名称'),
              prop: "platformOrderNo"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: form.value.templateName,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.templateName) = $event)),
                  style: {"width":"180px"},
                  maxlength: "50"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _unref(t)('类型'),
              prop: "platformOrderNo"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: form.value.templateType,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.templateType) = $event)),
                  style: {"width":"180px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: _unref(t)('全部'),
                      value: ""
                    }, null, 8, ["label"]),
                    _createVNode(_component_el_option, {
                      label: _unref(t)('商品附加项'),
                      value: 1
                    }, null, 8, ["label"]),
                    _createVNode(_component_el_option, {
                      label: _unref(t)('发货附加项'),
                      value: 2
                    }, null, 8, ["label"])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: search,
                  class: "btn"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('搜索')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_button, {
                  onClick: clear,
                  class: "btn"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('重置')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_el_button, {
          type: "primary",
          class: "addition-set-add",
          onClick: openCreateAdditionDialog
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('创建附加项组合')), 1)
          ]),
          _: 1
        }),
        _createVNode(STable, {
          ref_key: "STableRef",
          ref: STableRef,
          "page-data": pageData.value,
          "onUpdate:page-data": _cache[2] || (_cache[2] = ($event: any) => ((pageData).value = $event)),
          api: _unref(getCustomerAdditionTemplateListApi),
          columns: _unref(additionSetColumns),
          tableConfig: _unref(tableConfig),
          placement: "top",
          filterData: filterData.value
        }, {
          templateName: _withCtx(({ row }) => [
            _createElementVNode("div", null, _toDisplayString(row.templateName || '-'), 1)
          ]),
          additionName: _withCtx(({ row }) => [
            _createVNode(_component_el_tooltip, {
              effect: "light",
              placement: "top"
            }, {
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, _toDisplayString(row.additionName), 1)
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, _toDisplayString(row.additionName), 1)
              ]),
              _: 2
            }, 1024)
          ]),
          templateType: _withCtx(({ row }) => [
            _createElementVNode("div", null, _toDisplayString(row.templateType === 1 ? _unref(t)('商品附加项组合') : '') + " " + _toDisplayString(row.templateType === 2 ? _unref(t)('发货附加项组合') : ''), 1)
          ]),
          templateStatus: _withCtx(({ row }) => [
            _createElementVNode("div", null, [
              (row.templateStatus !== 0)
                ? (_openBlock(), _createBlock(_component_el_switch, {
                    key: 0,
                    "model-value": row.templateStatus === 1,
                    onClick: ($event: any) => (changeStatus(row))
                  }, null, 8, ["model-value", "onClick"]))
                : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_unref(t)('已失效2')), 1))
            ])
          ]),
          handler: _withCtx(({ scope }) => [
            _createVNode(_component_table_button, {
              title: _unref(t)('编辑'),
              disabled: !(scope.row.templateStatus !== 0 && scope.row.isDefault !== 1),
              onClick: ($event: any) => (openCreateAdditionDialog(scope.row)),
              loading: scope.row.loading
            }, null, 8, ["title", "disabled", "onClick", "loading"])
          ]),
          _: 1
        }, 8, ["page-data", "api", "columns", "tableConfig", "filterData"])
      ])
    ]),
    _createVNode(CreateAdditionTemplate, {
      visible: templateVisible.value,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((templateVisible).value = $event)),
      title: _unref(t)(!additionTemplateId.value ? _unref(t)('创建附加项组合') : '修改附加项组合'),
      proxy: proxy.value,
      onSubmit: _cache[4] || (_cache[4] = ($event: any) => (refreshTable(true)))
    }, null, 8, ["visible", "title", "proxy"])
  ], 64))
}
}

})